import { SelectedTaskColsFiltersHeader, getOnlySelectedHeaders } from '../../../../utils/hooks/tasks/useTaskConfigColumns'
import { DictTaskTableHeaderTy } from './types'

export const addHeadersToTmpColumnsMTC = (props: SelectedTaskColsFiltersHeader, headers: DictTaskTableHeaderTy) => {
    if (!props.selectedHeader) {
        props.selectedHeader = getOnlySelectedHeaders(headers, {})
    }
    return props
}